import React from "react";

const Team = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {teamMembers.map((member, index) => (
        <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-b-4 border-blue-500 group" key={index}>
           <img src={member.image} alt={member.name} className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-blue-200 group-hover:border-blue-400 transition-colors duration-300" 
           onError={(e) => { e.target.onerror = null; e.target.src = '[https://placehold.co/150x150/60A5FA/FFFFFF?text=Image+Unavailable](https://placehold.co/150x150/60A5FA/FFFFFF?text=Image+Unavailable)'; }}
           />
          <h3 className="text-2xl font-bold text-blue-800 mb-2 group-hover:text-blue-900 transition-colors duration-300">{member.name}</h3>
          <p className="text-blue-600 font-semibold mb-3">{member.position}</p>
          <p className="text-gray-700 text-sm">
            {member.description}
          </p>
      </div>))}
    </div>
  );
}


// import React from "react";

// const Team = () => {
//   return (
//     <section className="team_section layout_padding">
//       <div className="container-fluid">
//         <div className="heading_container heading_center">
//           <h2> <span>Our Team</span></h2>
//         </div>
//         <div className="team_container">
//           <div className="row">
//             {teamMembers.map((member, index) => (
//               <div className="col-lg-2 col-sm-6" key={index}>
//                 <div className="box">
//                   <div className="img-box">
//                     <img src={member.image} alt={member.name} className="img1" />
//                   </div>
//                   <div className="detail-box">
//                     <h5>{member.name}</h5>
//                     <p>{member.position}</p>
//                   </div>
//                   <div className="social_box">
//                     {member.socials.map((social, i) => (
//                       <a href={social.link} key={i}>
//                         <i className={`fa fa-${social.icon}`} aria-hidden="true"></i>
//                       </a>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

const teamMembers = [
  {
    name: "Vaibhav",
    position: "CEO (USA)",
    image: "images/VaibhavPatel.jpeg",
    description: "An expert in scalable web architectures and cloud solutions, bringing years of experience to complex projects.",
    socials: [
      { icon: "facebook", link: "https://www.facebook.com/celeritytecnocrats/" },
      { icon: "linkedin", link: "https://www.linkedin.com/company/celerity-technocrats/" }
      // { icon: "facebook", link: "https://www.facebook.com/vaibhavpatelsurat" },
      // { icon: "linkedin", link: "https://www.linkedin.com/in/vaibhav-patel-879362123/" },
//      { icon: "twitter", link: "#" },
//      { icon: "instagram", link: "#" },
//      { icon: "youtube-play", link: "#" }
    ]
  },
  /*{
    name: "Chetan Patel",
    position: "CTO",
    image: "images/ChetanPhoto.jpeg",
    socials: [
      { icon: "facebook", link: "https://www.facebook.com/celeritytecnocrats/" },
      { icon: "linkedin", link: "https://www.linkedin.com/company/celerity-technocrats/" }
      // { icon: "facebook", link: "https://www.facebook.com/chetanfpatel/" },
      // { icon: "twitter", link: "#" },
      // { icon: "linkedin", link: "https://www.linkedin.com/in/cfpatel/" },
      // { icon: "instagram", link: "https://www.instagram.com/cfpatel/" },
      // { icon: "youtube-play", link: "#" }
    ]
  },*/
  {
    name: "Disha",
    position: "Software Developer",
    image: "images/DishaPatel.jpeg",
    description: "An excellent problem solver, with exceptional skill in full stack development.",
    socials: [
      { icon: "facebook", link: "https://www.facebook.com/celeritytecnocrats/" },
      { icon: "linkedin", link: "https://www.linkedin.com/company/celerity-technocrats/" }
      // { icon: "instagram", link: "#" },
      // { icon: "youtube-play", link: "#" }
    ]
  },
  {
    name: "Jay",
    position: "Jr. Software Developer",
    image: "images/CelerityL.png",
    description: "Bringing out of the box solutions in AI and cutting edge technologies.",
    socials: [
      { icon: "facebook", link: "https://www.facebook.com/celeritytecnocrats/" },
      { icon: "linkedin", link: "https://www.linkedin.com/company/celerity-technocrats/" }
      // { icon: "instagram", link: "#" },
      // { icon: "youtube-play", link: "#" }
    ]
  }

  // Add more team members here
];

export default Team;